import type { VolunteerChoice } from '../types/volunteer';

export const registrationSteps = [
  'Parent Info',
  'Player Info',
  'Player Uniform',
  'Volunteer Info',
  'Cart',
  'Payment',
];

export const volunteerOptions: { id: VolunteerChoice; label: string; short: string }[] = [
  { id: 'myself', label: 'I want to volunteer - Myself', short: 'Volunteering – Myself' },
  { id: 'someone', label: 'I want to volunteer - Someone Else', short: 'Volunteering – Someone Else' },
  { id: 'maybe', label: 'Maybe - can I get more information?', short: 'Maybe – more information' },
  { id: 'no', label: "I don't want to volunteer", short: 'Not volunteering' },
];

export const relationshipOptions = [
  'Parent / Guardian',
  'Grandparent',
  'Relative',
  'Family friend',
  'Other',
];

export const volunteerIntro = {
  heading: 'Youth Sports thrive with Volunteer Coaches like You!',
  body: 'The youth sports system in America is based off getting great parents and volunteers to coach our kids as they develop and grow with sports. We at i9 Sports make coaching a fun and rewarding volunteer experience to help kids succeed in life through youth sports!',
  emphasis: 'No experience needed, we got you!',
};

export const coachCreditCopy = {
  heading: 'Coach this season and earn credit toward a future season',
  body: 'Eligible coaches who complete coaching and background-check requirements may receive a credit toward a future season registration.',
  footnote: "This is not a discount on today's registration.",
};
